import { StaticModal, createModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import { FormProvider } from 'react-hook-form';
import { TaskView } from '@nexelem/graphne-api';
import { useCustomTranslation } from '../../../../../../hooks';
import { AddTaskToPlanForm } from '../formComponents/AddTaskToPlanForm';
import { useAddTaskForm } from '../formComponents/useAddTaskForm';

type AddToPlanModalProps = {
  task: TaskView;
};

const AddToPlanModal = ({ task }: AddToPlanModalProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.addToPlanModal');

  const { form, onSubmit, isPending } = useAddTaskForm({
    taskId: task.id,
    taskName: task.name,
    onSuccess: closeAddTaskToPlanModal,
  });

  return (
    <StaticModal
      component="form"
      maxWidth="lg"
      onClose={closeAddTaskToPlanModal}
      onSubmit={form.handleSubmit(onSubmit)}
    >
      <FormProvider {...form}>
        <StaticModal.Header withCloseButton>{tWrapper('title')}</StaticModal.Header>
        <StaticModal.Content>
          <AddTaskToPlanForm isNewTask size="big" task={task} />
        </StaticModal.Content>
        <StaticModal.Footer>
          <Button variant="outlined" onClick={closeAddTaskToPlanModal}>
            {tWrapper('cancel')}
          </Button>
          <Button isLoading={isPending} type="submit" variant="contained">
            {tWrapper('confirmButton')}
          </Button>
        </StaticModal.Footer>
      </FormProvider>
    </StaticModal>
  );
};

export const { openAddTaskToPlanModal, closeAddTaskToPlanModal } = createModal(AddToPlanModal, {
  name: 'AddTaskToPlanModal',
});
